import React from 'react';
import { Header } from './Header';
import { Toaster } from 'react-hot-toast';

interface MainLayoutProps {
  children: React.ReactNode;
  onOpenStats: () => void;
  onOpenShop: () => void;
  onOpenAchievements: () => void;
  onOpenFortuneWheel: () => void;
  onOpenAdmin?: () => void;
  onOpenWallet?: () => void;
  walletAddress?: string | null;
  isAdmin?: boolean;
}

export function MainLayout({
  children,
  onOpenStats,
  onOpenShop,
  onOpenAchievements,
  onOpenFortuneWheel,
  onOpenAdmin,
  onOpenWallet,
  walletAddress,
  isAdmin = false,
}: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-gray-900 text-white overflow-x-hidden">
      <div className="fixed inset-0 pointer-events-none z-[-1]">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-black" />
      </div>

      <div className="relative z-10">
        <Toaster 
          position="top-right"
          containerStyle={{
            top: 20,
            right: 20,
            zIndex: 100
          }}
        />
        
        <Header
          onOpenStats={onOpenStats}
          onOpenShop={onOpenShop}
          onOpenAchievements={onOpenAchievements}
          onOpenFortuneWheel={onOpenFortuneWheel}
          onOpenAdmin={onOpenAdmin}
          onOpenWallet={onOpenWallet}
          walletAddress={walletAddress}
          isAdmin={isAdmin}
        />
        
        <main 
          className="container mx-auto px-4 py-8"
          style={{
            willChange: 'transform',
            transform: 'translateZ(0)',
            backfaceVisibility: 'hidden'
          }}
        >
          {children}
        </main>
      </div>
    </div>
  );
}